import { Component, type ReactNode } from "react";

/** Isolate optional chunk failures so the surrounding shell and conversation remain usable. */
export class ZarvisLazyBoundary extends Component<
  { children: ReactNode; fallback: ReactNode },
  { failed: boolean }
> {
  override state = { failed: false };

  static getDerivedStateFromError(): { failed: boolean } {
    return { failed: true };
  }

  override render(): ReactNode {
    return this.state.failed ? this.props.fallback : this.props.children;
  }
}
